// Lib
import React, { useCallback, useState } from 'react';
import { Typography } from '@mui/material';
import { useSelector } from 'react-redux';

// Components
import ProductRatingCard from './ProductRatingCard';
import FooterButtons from '../../Modal/FooterButtons';

// Hooks
import use2Modal from '../../../hooks/use2Modal';

// Utils
import { isObjEmpty } from '../../../utils/object';

// Selectors
import { productsObjSelector } from '../../../store/selectors';

// Styles
import { useStyles } from './RatingCardStyles';

const RatingCard = ({ onSave = () => {}, updateProductRating = () => {} }) => {
  const { classes } = useStyles();
  const { onClose } = use2Modal();
  const { productsForRate, productsObj } = useSelector((state) => ({
    productsForRate: state.cart.forRate,
    productsObj: productsObjSelector(state),
  }));
  const [notRatedProducts, setNotRatedProducts] = useState({});
  const [loading, setLoading] = useState(false);

  const onSaveRating = useCallback(() => {
    const errors = {};
    productsForRate.forEach((product) => {
      if (!product.user_rate) {
        errors[product.product_id] = 'Product is not rated';
      }
    });
    if (isObjEmpty(errors)) {
      onSave(productsForRate, setLoading);
    } else {
      setNotRatedProducts(errors);
    }
  }, [onSave, productsForRate, setNotRatedProducts, setLoading]);

  return (
    <>
      <Typography variant="h2" className={classes.title}>
        Please rate these products before going to the next step.
      </Typography>
      {productsForRate.map((product) => (
        <ProductRatingCard
          notRatedProducts={notRatedProducts}
          key={product.product_id}
          product={{
            ...productsObj[product.product_id],
            user_rate: product.user_rate,
          }}
          updateProductRating={updateProductRating}
        />
      ))}
      <FooterButtons
        className={classes.buttons}
        acceptTitle="Save"
        rejectTitle="Cancel"
        onReject={onClose}
        onAccept={onSaveRating}
        isLoading={loading}
      />
    </>
  );
};

export default RatingCard;
